export const WHATSAPP_WORKSPACE_TAB_IDS = ["connection", "templates"] as const;

export type WhatsAppWorkspaceTab = (typeof WHATSAPP_WORKSPACE_TAB_IDS)[number];

export const DEFAULT_WHATSAPP_WORKSPACE_TAB: WhatsAppWorkspaceTab = "connection";

export function isWhatsAppWorkspaceTab(value: string | null): value is WhatsAppWorkspaceTab {
  return value === "connection" || value === "templates";
}

export function parseWhatsAppWorkspaceTab(
  searchParams: URLSearchParams,
): WhatsAppWorkspaceTab {
  const raw = searchParams.get("tab");
  return isWhatsAppWorkspaceTab(raw) ? raw : DEFAULT_WHATSAPP_WORKSPACE_TAB;
}

export function buildWhatsAppWorkspaceSearchParams(
  current: URLSearchParams,
  tab: WhatsAppWorkspaceTab,
): URLSearchParams {
  const next = new URLSearchParams(current);
  next.set("tab", tab);
  return next;
}

export function shouldNormalizeWhatsAppWorkspaceTab(searchParams: URLSearchParams): boolean {
  return searchParams.get("tab") !== parseWhatsAppWorkspaceTab(searchParams);
}
